import React from "react";
import { Container } from "react-bootstrap";
import "./index.scss";

const steps = [
  {
    number: "01",
    title: "Remplissez le formulaire",
   
  },
  {
    number: "02",
    title: "Recevez votre simulation personnalisée",

  },
  {
    number: "03",
    title: "Passez à l’action avec nos experts",

  },
];

const TimelineSection = () => {
  return (
    <section className="timeline-section py-5 d-md-none d-block">
          <div className="text-center ">
        <h2 className="section-title">Comment ça marche ?</h2>
        <p className="section-subtitle mb-5">
         Notre méthode éprouvée, pensée pour transformer <br/>vos idées en résultats mesurables.
        </p>
        </div>
      <Container>
        <div className="timeline">
          {steps.map((step, index) => (
            <div key={index} className="timeline-step">
              <div className="timeline-marker" />
              <div className="timeline-content">
                <h2 className="step-number">{step.number}</h2>
                <h3 className="step-title1">{step.title}</h3>
                <p className="step-subtitle">{step.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default TimelineSection;
